<template>
  <div class="bb">
    <img class="an1" src="@/assets/close0.png" alt />
    <img class="an2" src="@/assets/wind1.png" alt />
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.bb {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  .an1 {
    position: absolute;
    width: 1.5rem;
    height: 1.5rem;
    left: 0;
    top: 0;
    animation: srotate 2s infinite linear;
  }
  .an2 {
    position: absolute;
    width: 1rem;
    height: 1rem;
    left: 50%;
    top: 50%;
    margin-left: -0.5rem;
    margin-top: -0.5rem;
    animation: srotate 2s infinite linear;
  }
}

// 顺时针旋转
@keyframes srotate {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
// 逆时针旋转
@keyframes nrotate {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-90deg);
  }
  50% {
    transform: rotate(-180deg);
  }
  75% {
    transform: rotate(-270deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>>